import React from 'react';
import WizardRadioControlledComponent from 'components/v2/epd-wizard-inputs/WizardRadioControlled';
import { RadioListInputRecord } from 'types/dynamic-forms/records/RadioListInputRecord';
import { DocumentDataSourceOption } from 'types/dynamic-forms/DocumentDataSourceOption';
import useProperty from '../hooks/useProperty';
import usePropertyPath from '../hooks/usePropertyPath';
import useDataSource from '../hooks/useDataSource';

const RadioListInputRenderer: React.FC<RadioListInputRecord> = ({ propertyId, label, tooltip }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, errorMessage, isDisabled } = useProperty<string | null>(propertyPath);
  const { options } = useDataSource(propertyPath);
  
  if (!isVisible) {
    return null;
  }

  // Convert DocumentDataSourceOption to Option format
  const radioOptions = options.map((opt: DocumentDataSourceOption) => ({
    label: opt.label,
    value: opt.value,
    isDisabled: false,
  }));

  return (
    <WizardRadioControlledComponent
      name={propertyId}
      options={radioOptions}
      value={value}
      label={label}
      tooltip={tooltip}
      onChanged={(_: string, value: any) => setValue(value ?? null)}
      error={errorMessage ?? undefined}
      disabled={isDisabled}
    />
  );
};

export default RadioListInputRenderer;

